module.exports = __webpack_public_path__ + "static/img/join_bg.9c29f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_bg.png
// module id = KxTu
// module chunks = 1